export default "__VITE_ASSET__R6He9xPN__"